import { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getAgentBalance, getBBTLoginCompany, getBBTPaymentConfig, getBBTViaListCities, getBusTripGPSDetails, getCancellationPoliciesV3, getCompanyAgentsRightsListAll, getGPSCacheStatus, getRouteDetails } from "../redux/Booking/BookingActions";
import dayjs from "dayjs";
import { showErrorAlert, updateLoadingScreen } from "../redux/Actions";
import { bkgDetailsObj, bkgTypeOptList, chartFormatData, filterOptObj, formatCancelPolicy, paymentOptList, seatDefaultObj } from "../components/Booking/constant";
import moment from "moment/moment";
import { gstIconStatusData } from "../utils/helpers";

export const useLoadTripDetails = () => {
    const dispatch = useDispatch()
    const store = useSelector((store) => store);
    const { user } = store;
    const { userDetails } = user;

    // Hook implementation goes here
    const loadTripDetails = useCallback(async ({ tripDetails = {}, setBkgDetails, setFilterOpt, setSelectedSeat, deleteCache = false }) => {

        const body = {
            intAgentID: userDetails.AgentID || 0,
            intTripID: tripDetails.TripID || 0
        }
        const routeDetailsBody = {
            intcompanyID: tripDetails?.CompanyChartID,
            strRouteSchId: `${tripDetails?.ServiceID}~${tripDetails.TripID}~${tripDetails.FromCityID}~${tripDetails.ToCityID}~${dayjs(tripDetails.ChartDate, 'DD-MMM-YYYY').format('YYYY-MM-DD')}`,
            month: dayjs(tripDetails.JourneyDate, 'DD-MMM-YYYY').format('MM'),
            day: dayjs(tripDetails.JourneyDate, 'DD-MMM-YYYY').format('DD'),
            year: dayjs(tripDetails.JourneyDate, 'DD-MMM-YYYY').format('YYYY'),
            intAgentId: userDetails?.AgentID || 0,
            JTime: tripDetails?.TripTime || '',
            intDiscountPolicyid: tripDetails.HasDiscountPolicy || 0,
        }

        const cancelPolicyBody = {
            intAgentID: userDetails?.AgentID || 0,
            strRouteCode: `${tripDetails?.ServiceID}~${tripDetails.TripID}~${tripDetails.FromCityID}~${tripDetails.ToCityID}~${dayjs(tripDetails.ChartDate, 'DD-MMM-YYYY').format('YYYY-MM-DD')}`
        }

        const roleBody = {
            intUserID: userDetails?.AgentUserID || 0,
            intCompanyID: tripDetails?.CompanyID,
            intAgentID: userDetails?.AgentID || 0,
        }

        const payConfigBody = {
            intCompanyID: tripDetails?.CompanyID,
            intAgentID: userDetails?.AgentID || 0,
            intTripID: tripDetails.TripID,
            intFromCityID: tripDetails.FromCityID,
            intToCityID: tripDetails.ToCityID,
            intFareSeater: 0,
            intFareSlpr: 0,
            intFareSlm: 0,
        }

        const agentBalBody = {
            intCompanyID: tripDetails?.CompanyID,
            intAgentID: userDetails?.AgentID || 0
        }
        const gpsBody = {
            intTripId: tripDetails?.TripID,
            dtChartDate: dayjs(tripDetails.ChartDate, 'DD-MMM-YYYY').format('YYYY-MM-DD'),
            IsCacheForceUpdate: false
        }

        const vialvityBody = {
            intTripID: tripDetails?.TripID,
            intCompanyID: tripDetails?.CompanyID
        }

        const gspBody = {
            intTripID: tripDetails?.TripID,
            dtchartdate: moment(tripDetails?.ChartDate, 'DD-MMMM-YYYY').format('YYYY-MM-DD')
        }
        dispatch(getBBTLoginCompany(body)).then((resCompany) => {
            if (resCompany.data.status) {
                let parseCompany = JSON.parse(resCompany.data.Data)?.Table || []
                let tripCompanyID = parseCompany?.length === 1 && parseCompany?.[0].QuotaByCompanyID !== 0 ? parseCompany?.[0].QuotaByCompanyID : tripDetails?.CompanyID

                const promise = [
                    dispatch(getRouteDetails(routeDetailsBody, false, 15 * 1000, deleteCache)),
                    dispatch(getCancellationPoliciesV3(cancelPolicyBody)),
                    dispatch(getCompanyAgentsRightsListAll({ ...roleBody, intCompanyID: tripCompanyID })),
                    dispatch(getBBTPaymentConfig({ ...payConfigBody, intCompanyID: tripCompanyID })),
                    dispatch(getAgentBalance(agentBalBody)),
                    dispatch(getBBTViaListCities(vialvityBody)),
                ]
                if (tripDetails?.BusNumber?.trim() !== '' && tripDetails?.BusNumber !== null) {
                    promise.push(dispatch(getBusTripGPSDetails(gspBody)))
                }
                Promise.all(promise).then((res) => {
                    if (res?.[0].data?.status && res?.[1].data?.status && res?.[2].data?.status && res?.[3]?.data?.status && res?.[5]?.data?.status) {
                        let parseData = JSON.parse(res?.[0].data.Data || '{}')
                        let cancelPolicyData = (res?.[1].data?.Data?.Table || []).sort((a, b) => a.MinsBefore - b.MinsBefore)
                        let roleRight = JSON.parse(res?.[2].data.Data || '{}')?.Table?.[0] || {}

                        let parsePayment = JSON.parse(res?.[3].data.Data || '{}')?.Table?.[0] || {}
                        let commAmt = JSON.parse(res?.[3].data.Data || '{}')?.Table1?.[0] || {}
                        let gstData = res?.[6]?.data?.data?.Table?.[0] || {}
                        let routeCity = JSON.parse(res?.[5].data.Data || '{}')?.Table || []
                        let paymentList = paymentOptList.filter((obj) => (obj.id === parsePayment?.BbtPaymentMode || parsePayment?.BbtPaymentMode === 0))
                        const pickUp = ((parseData?.PickUpTable || []).map((obj) => ({ ...obj, label: `${dayjs(obj.pickup_time, 'YYYY-MM-DD hh:mm:ss A').format('DD-MMM-YYYY hh:mm A')} | ${obj.pickup_name} ${(obj.pickupCharge_per !== 0 || obj.pickupCharge_rs !== 0) ? obj.pickupCharge_per !== 0 ? ` | Extra Per Seat ${obj.pickupCharge_per}%` : `| Extra Per Seat Rs. ${obj.pickupCharge_rs}` : ''}` }))).sort((a, b) => dayjs(a.pickup_time, 'YYYY-MM-DD hh:mm:ss A') - dayjs(b.pickup_time, 'YYYY-MM-DD hh:mm:ss A'));
                        const dropOff = ((parseData?.DropOffTable || []).map((obj) => ({ ...obj, label: `${dayjs(obj.DropoffTime, 'YYYY-MM-DD hh:mm:ss A').format('DD-MMM-YYYY hh:mm A')} | ${obj.DropoffName} ${(obj.DropoffChargeRs !== 0 || obj.DropoffChargePer !== 0) ? obj.DropoffChargePer !== 0 ? `| Extra Per Seat ${obj.DropoffChargePer}%` : `| Extra Per Seat Rs. ${obj.DropoffChargeRs}` : ''}` }))).sort((a, b) => dayjs(a.DropoffTime, 'YYYY-MM-DD hh:mm:ss A') - dayjs(b.DropoffTime, 'YYYY-MM-DD hh:mm:ss A'));
                        let bkgData = parseData.BookingStatus_1 || []

                        let bkyTypeList = bkgTypeOptList.filter((obj) => roleRight?.[obj.field] === 1)



                        setFilterOpt((prev) => ({
                            ...prev,
                            ...filterOptObj,
                            chartData: chartFormatData(parseData?.SeatChart_2 || [], bkgData, userDetails, roleRight),
                            pickUp: pickUp,
                            dropOff: dropOff,
                            bkgType: bkyTypeList,
                            paymentMode: paymentList,
                            allPaymentMode: paymentList,
                        }))
                        let phoneNumber = localStorage.getItem('BBTPhoneNumber')
                        let psgName = localStorage.getItem('BBTPsgName')
                        setBkgDetails((prev) => ({
                            ...prev,
                            ...bkgDetailsObj,
                            phoneNumber,
                            routeCity: routeCity,
                            roleRight: roleRight,
                            pickUp: pickUp.length > 0 ? [pickUp[0]] : [],
                            dropOff: dropOff.length > 0 ? [dropOff[0]] : [],
                            tripDetails: tripDetails,
                            cancelPolicyData: formatCancelPolicy(cancelPolicyData),
                            bkgType: bkyTypeList.length > 0 ? [bkyTypeList[0]] : [],
                            autoCancelMins: Number(tripDetails?.AutoCancelMins || 0),
                            seaterHigh: tripDetails?.SeaterHigh || 0,
                            seaterLow: tripDetails?.SeaterLow || 0,
                            sleeperHigh: tripDetails?.SleeperHigh || 0,
                            sleeperLow: tripDetails?.SleeperLow || 0,
                            slumberHigh: tripDetails?.SlumberHigh || 0,
                            slumberLow: tripDetails?.SlumberLow || 0,
                            serviceTaxPct: tripDetails.ServiceTaxPct || 0,
                            hasSTax: tripDetails?.HasSTax || false,
                            hasDiscountPolicy: tripDetails?.HasDiscountPolicy === 1 || false,
                            discountAmt: Number(tripDetails.DiscountAmt || 0),
                            discountPer: Number(tripDetails.DiscountPer || 0),
                            paymentMode: paymentList.length > 0 ? [paymentList[0]] : [],
                            CommissionAmt: Number(commAmt.CommissionAmt || 0),
                            CommissionPer: Number(commAmt.CommissionPer || 0),
                            CommseatAmt: Number(commAmt.CommseatAmt || 0),
                            CommslprAmt: Number(commAmt.CommslprAmt || 0),
                            tripCompanyID,
                            agentBalance: res?.[4]?.data?.Data?.Table?.[0]?.AgentBalance || 0,
                            isDisableRemarks: Number(roleRight?.IsDisableRemarksOnlineAgents) === 1,
                            gstData,
                            limitOnFareChange: Number(roleRight?.LimitOnFareChange || 0),
                            limitOnFareChangePer: Number(roleRight?.LimitOnFareChangePer || 0)
                        }))
                        setSelectedSeat([{ ...seatDefaultObj, name: psgName }])
                    } else {
                        dispatch(showErrorAlert(`${res?.[0].data.Message} ${res?.[1].data.Message} ${res?.[2].data?.Message} ${res?.[3]?.data?.Message}`))
                    }

                }).catch((error) => {
                    // Handle error
                    dispatch(showErrorAlert(error))
                });


            } else {
                dispatch(updateLoadingScreen(false))
                dispatch(showErrorAlert(resCompany.data.Message))
            }

        })



    }, [dispatch, userDetails])
    return { loadTripDetails }
}